export const AFFILIATE_LABEL = "Affiliate link";

export const AFFILIATE_DISCLOSURE =
  "We may earn a commission from this link. This does not influence our scoring, ranking, odds calculations, operator trust notes, or whether a competition is shown.";

const normaliseUrl = (value) => String(value || "").trim();

const sameUrl = (left, right) => {
  const a = normaliseUrl(left);
  const b = normaliseUrl(right);
  return Boolean(a && b && a === b);
};

export function affiliateDisclosureFor(record = {}, destinationUrl) {
  const outboundType = String(record.outbound_link_type || "").trim().toLowerCase();
  const ctaTarget = String(record.cta_target || "").trim().toLowerCase();
  const affiliateUrl = normaliseUrl(record.affiliate_url);
  const destination = normaliseUrl(destinationUrl);
  const explicitAffiliate =
    record.is_affiliate_link === true ||
    record.is_affiliate === true ||
    record.is_partner_link === true ||
    Boolean(record.affiliate_label) ||
    Boolean(record.affiliate_disclosure) ||
    outboundType === "affiliate" ||
    outboundType === "partner" ||
    ctaTarget === "affiliate" ||
    ctaTarget === "partner" ||
    Boolean(affiliateUrl && (!destination || sameUrl(destination, affiliateUrl)));

  return {
    isAffiliateLink: explicitAffiliate,
    label: explicitAffiliate ? (record.affiliate_label || AFFILIATE_LABEL) : null,
    disclosure: explicitAffiliate
      ? (record.affiliate_disclosure || AFFILIATE_DISCLOSURE)
      : null,
    outboundLinkType: explicitAffiliate
      ? (outboundType || ctaTarget || "affiliate")
      : (outboundType || "standard"),
  };
}
